import { render, staticRenderFns } from "./DocumentSelectionSimpleDialog.vue?vue&type=template&id=2c053467&"
import script from "./DocumentSelectionSimpleDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelectionSimpleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports